module.exports = __webpack_public_path__ + "img/vmc_aniv8_24Aug2021.15b326ac.jpg";